import { Card, Tabs } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { DeliveryNote } from "../types/deliveryNote.interfaces"
import { DeliveryNoteTabContent } from "./DeliveryNoteTabContent"
import { DeliveryNoteVendorTabContent } from "./DeliveryNoteVendorTab"

interface DeliveryNotesDetailsSectionProps {
    deliveryNote: DeliveryNote
}

export const DeliveryNotesDetailsSection = ({ deliveryNote }: DeliveryNotesDetailsSectionProps) => {
    const { t } = useTranslation()

    return (
        <Card className="card-with-tabs" id="expense-source-section">
            <Tabs
                defaultActiveKey="purchaseData"
                className="mb-8"
                items={[
                    {
                        key: "deliveryNoteData",
                        label: t("label:delivery_data"),
                        children: <DeliveryNoteTabContent deliveryNote={deliveryNote} />,
                    },
                    {
                        key: "vendorData",
                        label: t("label:vendor_data"),
                        children: <DeliveryNoteVendorTabContent deliveryNote={deliveryNote} />,
                    },
                ]}
            />
        </Card>
    )
}
